<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"
            :actions="actions"
            :ajax-params="ajaxParams"
            :refresh.sync="refreshTable"
            :loading="tableIsLoading"
            ajax-path="nable/devices"
            @rowSelected="handleRowSelected"     
        />
    </div>
</template>

<script>
    export default {
        data() {
            return {
                tableIsLoading: false,
                refreshTable: false,
                ajaxParams:{},
                columns: [
                    {
                        title: 'Customer',
                        field: 'customername',
                        sorter: 'string',
                        minWidth: 250,
                    },
                    {
                        title: 'Site',
                        field: 'sitename',
                        sorter: 'string',
                        minWidth: 150,
                        formatter({_cell}) {
                            if (_cell.value) {
                                return _cell.value;
                            }

                            return '--';
                        },
                    },
                    {
                        title: 'Name',
                        field: 'discoveredname',
                        sorter: 'string',
                        minWidth: 250,
                        formatter({_cell}) {
                            if (_cell.value) {
                                return _cell.value;
                            }

                            return '--';
                        },
                    },
                    {
                        title: 'Network Address',
                        field: 'uri',
                        sorter: 'string',
                        minWidth: 300,
                    },
                    {
                        title: 'Status',
                        field: 'statestatus',
                        sorter: 'string',
                        minWidth: 150,
                    },
                    {
                        title: 'Device Class',
                        field: 'deviceclass',
                        sorter: 'string',
                        minWidth: 200,
                    },
                    {
                        title: 'Agent Version',
                        field: 'agentversion',
                        sorter: 'string',
                        minWidth: 150,
                    },
                    {
                        title: 'Logged in User',
                        field: 'lastloggedinuser',
                        sorter: 'string',
                        minWidth: 250,
                    },
                ],
                actions: [],
            }
        },
        methods: {
            handleRowSelected(selected) {

            }
        }
    }
</script>